import React from 'react';
import { Alert } from 'antd';

import { FormattedMessage } from '../../util/reactIntl';

/**
 * On a job or RFP a sub-supplier reads only because a supplier it works with shared it: who shared
 * it, and that candidates go forward through them. The sub-supplier cannot apply itself.
 */
const ForwardedPostingNotice = ({ sharedBy }) => {
  const names = (Array.isArray(sharedBy) ? sharedBy : []).filter(Boolean).join(', ');
  return (
    <Alert
      type="info"
      showIcon
      data-testid="forwarded-posting-notice"
      message={<FormattedMessage id="ListingPage.forwardedNotice" values={{ prime: names }} />}
    />
  );
};

export default ForwardedPostingNotice;
